import angular from 'angular';

const ApiMocks = angular.module('mockservices', []).service('mockService', ['$sce', function($sce) {
    
    this.getTruevalue = function() {
            return true;
    };
    this.getFalsevalue = function() {
            return false;
    };

}]);

export default ApiMocks;



// WEBPACK FOOTER //
// ./client/app/mock/mock.js